'use strict';

wbApp.controller('CzMsMtRegistryStudentRecordsCtrl', ['$scope', '$q', '$modal', '$window', '$translate', '$filter', 'securitySvc', 'tenantSettingSvc', 'czMsMtRegistrySvc', 'gridSortSvc',
function ($scope, $q, $modal, $window, $translate, $filter, securitySvc, tenantSettingSvc, czMsMtRegistrySvc, gridSortSvc) {

    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.selectedStudentInd = {};
    let isActive = false;
    let loaded = false;
    $scope.studentRecords = [];

    function refreshData(studentId) {
        $scope.studentRecords = czMsMtRegistrySvc.findByStudent(studentId);
    }
    
    
    $scope.$on('selectedStudentChanged', function (e, studentInd) {
        if (studentInd.studentId) {
            if (isActive) {
                if ($scope.selectedStudentInd.studentId !== studentInd.studentId || studentInd.refresh) {
                    refreshData(studentInd.studentId);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.studentRecords = [];
        }
        $scope.selectedStudentInd = studentInd;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.selectedStudentInd && $scope.selectedStudentInd.studentId) {
                    refreshData($scope.selectedStudentInd.studentId);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.studentRecordsGridSettings = {
        name: 'studentRecords',
        columns: [
            {
                dataField: 'studentSurname',
                caption: $translate.instant('TXT_LBL_STUDENT'),
                dataType: 'string',

                calculateCellValue: function (rowData) {
                    return String.prototype.fullName(rowData.studentName, rowData.studentMiddleName, rowData.studentSurname);
                }
            },
            { dataField: 'semesterName', caption: $translate.instant('TXT_LBL_SEMESTER'), dataType: 'string',  width: '110px',},
            { dataField: 'activityName', caption: $translate.instant('TXT_LBL_ACTIVITY'), dataType: 'string',  width: '110px',},
            { dataField: 'validFromUtc', caption: $translate.instant('TXT_LAB_VALID_FROM'), dataType: 'date', format: { type: 'shortDate' }, width: '90px', sortOrder: 'desc' },
            { dataField: 'validToUtc', caption: $translate.instant('TXT_LAB_VALID_TO'), dataType: 'date', format: { type: 'shortDate' }, width: '90px' },
            { dataField: 'isValid', caption: 'Validní', dataType: 'boolean', width: '60px' },
            { dataField: 'requireSpecialEducation', caption: 'Spec', dataType: 'boolean', width: '60px' },
        ],
        shouldDisableDelete: function () { return !$scope.selectedRecord1 || !$scope.selectedRecord1.isLast; },
        onRowPrepared: function (e) {
            if (e.rowType === "data" && $scope.selectedStudentInd) {
                let data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.id === $scope.selectedStudentInd.recordId) {
                    e.rowElement.addClass('text-success');
                }
            }
        },
        // onCellPrepared: function (e) {
        //     if (e.rowType === "data" && e.columnIndex == 2) {
        //         e.cellElement.mousemove(function () {
        //             if (!!e.data.studentBirthday) {
        //                 e.cellElement.attr('title', $translate.instant("TXT_LAB_BIRTHDAY") + ": " + $filter('date')(e.data.studentBirthday, 'shortDate'));
        //             }
        //         });
        //     }
        // },
        // customCommands: [{
        //     text: $translate.instant('TXT_MENU_CREATE_PAYMENT'),
        //     isVisible: function (row) { return (row.arrear > 0) && securitySvc.isInRole('Payment.Insert'); },
        //     callback: function (row) { addPayment(row); }
        // },{
        //     text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
        //     isVisible: function () { return securitySvc.isInRole('Reports') && securitySvc.isInRole('CourseRegistration.PrintInvoice'); },
        //     callback: function (data) { onPrintInvoice(data.courseRegistrationID); }
        // }, {
        //     text: $translate.instant('TXT_MENU_PRINT_APPLICATION_FORM'),
        //     isVisible: function () { return securitySvc.isInRole('Reports') && securitySvc.isInRole('CourseRegistration.PrintApplicationForm'); },
        //     callback: function (data) { onPrintApplicationForm(data.courseRegistrationID); }
        // }, {
        //     text: $translate.instant('TXT_MENU_PRINT_INFO_CARD'),
        //     isVisible: function () { return securitySvc.isInRole('Course.InfoCard') && securitySvc.isInRole('Reports'); },
        //     callback: function (data) { onPrintInfoCard(data.courseID, data.studentID); }
        // }, {
        //     text: $translate.instant('TXT_MENU_RESEND_COURSE_REGISTRATION_NOTIFICATION'),
        //     isVisible: function () { return securitySvc.isInRole('CourseRegistration'); },
        //     callback: function (data) {
        //         courseRegistrationSvc.sendRegistrationNotification(data.courseRegistrationID)
        //         .then(function () {
        //             data.notificationSent = true;
        //         });
        //     }
        // }]
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedRecord1 = data;
    }
    
    // $scope.onRowEdit = function (data) {
    //     detailDialogPromise.$promise.then(function () {
    //         detailDialogPromise.$scope.course = $scope.selectedCourse;
    //         detailDialogPromise.$scope.model = new webooker_courses_models.CourseRegistration(data);
    //         detailDialogPromise.$scope.onAfterSuccessSave = function () {
    //             $scope.courseRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedCourse.courseID);
    //             onCourseScheduleChanged();
    //         }
    //         detailDialogPromise.show();
    //     });
    // }
    //
    // $scope.onRowAdd = function () {
    //
    //     $q.all([detailDialogPromise.$promise, courseRegistrationSvc.createNew($scope.selectedCourse, false)])
    //     .then(function (data) {
    //         var courseRegistration = data[1];
    //         detailDialogPromise.$scope.course = $scope.selectedCourse;
    //         detailDialogPromise.$scope.model = courseRegistration;
    //         detailDialogPromise.$scope.onAfterSuccessSave = function () {
    //             $scope.courseRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedCourse.courseID);
    //             onCourseScheduleChanged();
    //         }
    //         detailDialogPromise.show();
    //     });
    // }
    //
    $scope.onRowDelete = function (data) {
        czMsMtRegistrySvc.remove(data.id).$promise.then(function () {
            refreshData($scope.selectedStudentInd.studentId);
            $scope.$emit('refreshData', null);
            $scope.selectedRecord1 = null;
        });
    }

    $scope.onRowEdit = function (data) {

        let modelPromise = czMsMtRegistrySvc.getById(data.id);
        $q.all([modelPromise.$promise, detailDialogPromise.$promise]).then(function() {
            detailDialogPromise.$scope.model = modelPromise;
            detailDialogPromise.$scope.onRegistryDetailSave = function () {
                refreshData($scope.selectedStudentInd.studentId);
                $scope.$emit('refreshData', null);
            };
            detailDialogPromise.show();

        });
    }

    let detailDialogPromise = $modal({
        templateUrl: 'cz-ms-mt-registry/cz-ms-mt-registry-detail.html',
        show: false,
        scope: $scope
    });

}]);
